'use client';
import React from 'react';
const MINUTE_IN_MS = 1e3 * 60;
export const MAX_DELAY = 60 * MINUTE_IN_MS;
export const INACTIVE_THRESHOLD = MINUTE_IN_MS / 2;
export const MIN_VERSION_REFRESH_CHECK_INTERVAL = 15 * MINUTE_IN_MS;
export const CHANNEL_NAME = 'internal-refresh';
export const DISPLAY_MANUAL_REFRESH_TIMEOUT = 2 * 24 * 60 * 60 * 1e3;
export const MANUAL_REFRESH_TOAST_DEDUP_KEY = 'manual-build-version-refresh';
export const RefreshProviderRefDefaults = {
    isOutdated: () => false,
    canRefresh: () => false,
    refresh: async () => false,
    channel: null,
};
//# sourceMappingURL=RefreshSideEffectsShared.js.map